import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { DsmDecorConsultant, DsmDecorConsultantLookup } from '../models/dsm-decor-consultant.models';

@Injectable({ providedIn: 'root' })
export class DsmDecorConsultantService {
  readonly #api = inject(ApiCallingV2Service);
  readonly #baseUrl = inject(API_CONFIG).baseUrlV2;

  readAvailableConsultants(): Observable<DsmDecorConsultant[]> {
    return this.#api
      .getData<DsmDecorConsultant[]>(`${this.#baseUrl}/Lot/decor-consultants`, {
        showLoader: false,
        showMessage: false
      })
      .pipe(map((consultants: DsmDecorConsultant[] | null) => consultants ?? []));
  }

  getDecorConsultants(projectIds: string[]): Observable<DsmDecorConsultantLookup[]> {
    return this.#api
      .postData<
        DsmDecorConsultantLookup[]
      >(`${this.#baseUrl}/dsm/users/decor-consultants`, { showLoader: false, showMessage: false }, projectIds)
      .pipe(map((consultants: DsmDecorConsultantLookup[] | null) => consultants ?? []));
  }

  readLotConsultant(lotId: string): Observable<DsmDecorConsultant | null> {
    return this.#api
      .getData<DsmDecorConsultant>(`${this.#baseUrl}/Lot/${lotId}/decor-consultant`, {
        showLoader: false,
        showMessage: false,
        showError: false
      })
      .pipe(
        map((consultant: DsmDecorConsultant | null) => consultant ?? null),
        catchError((error: HttpErrorResponse) => (error.status === 404 ? of(null) : throwError(() => error)))
      );
  }

  assignConsultant(lotId: string, decorConsultantId: string): Observable<void> {
    return this.#api.putData<void>(
      `${this.#baseUrl}/Lot/${lotId}/decor-consultant`,
      { decorConsultantId },
      { showLoader: true, showMessage: true }
    );
  }

  unassignConsultant(lotId: string): Observable<void> {
    return this.#api.deleteData<void>(`${this.#baseUrl}/Lot/${lotId}/decor-consultant`, {
      showLoader: true,
      showMessage: true
    });
  }
}
